import { IonPage, IonInput, IonButton, IonSlides, IonGrid, IonItem, IonTabs, IonTabBar, IonTabButton, IonMenu, IonToolbar, IonTitle, IonContent, IonList, IonHeader, IonMenuToggle, IonLabel, IonSplitPane, IonRouterOutlet, IonFooter, IonModal, IonText, IonDatetime, IonRefresher, IonRefresherContent } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonIcon, IonButtons, IonMenuButton, IonImg } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect} from 'react';

import '../../../css/layout.css';

import { ViewAvailableRoomsModal } from './Modal_ViewAvailableRooms';
import { ViewOccupiedRoomsModal } from './Modal_ViewOccupiedRooms';
import { ViewBookedRoomsModal } from './Modal_ViewBookedRooms';
import { ViewNeedCleaningRoomsModal } from './Modal_ViewNeedCleaningRooms';

import {DateRange} from '../../../zInternal_Features/merchant/components/DateRange'


import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { PushNotifiPushNotificationSchema, PushNotifications, Token, ActionPerformed } from '@capacitor/push-notifications';
import { Toast } from "@capacitor/toast";


export function CheckIn_CheckOutSlides(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    //alert('In CheckIn_CheckOutSlides')
    //alert(authenticatedMerchent_context.acctID);
    //alert(authenticatedMerchent_context.accessRights);
    //alert(authenticatedMerchent_context.accessRights[0]);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(new Date(new Date().setDate(new Date().getDate())));
    let [endDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate()+1)));

    let [startDate_display, setStartDate_display] = useState(false);
    let [endDate_display, setEndDate_display] = useState(false);

    let [numRoomsAvailable, setNumRoomsAvailable] = useState(null);
    let [numRoomsOccupied, setNumRoomsOccupied] = useState(null);
    let [numRoomsBooked, setNumRoomsBooked] = useState(null);
    let [numRoomsNeedCleaning, setNumRoomsNeedCleaning] = useState(null);

    let [searchGuestData, setSearchGuestData] = useState(null);

    let [showAvailableRoomsModal, setShowAvailableRoomsModal] = useState(false);
    let [showOccupiedRoomsModal, setShowOccupiedRoomsModal] = useState(false);
    let [showBookedRoomsModal, setShowBookedRoomsModal] = useState(false);
    let [showNeedCleaningRoomsModal, setShowNeedCleaningRoomsModal] = useState(false);


    let [notifications, setnotifications] = useState([]);

    function searchGuestDataHandler(e) {
        
        setSearchGuestData(e.target.value);
    }

    function reloadDates(event)
    {
        // alert('In Reload')
        // alert(event)
        // alert(event[0])
        // alert(event[1])

        
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: 74100,
                user: acctID,
                xStartDateRange: event[0],
                xEndDateRange: event[1],
                sessionID: sessionID,
            })

            
        }

    
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            // alert(res);
            // alert(window.location.pathname)

            let rows = res.toString().split('~~~');
            let rowLength = rows.length;

                for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setNumRoomsAvailable(cols[0]);
                    setNumRoomsOccupied(cols[1]);
                    setNumRoomsBooked(cols[2]);
                    setNumRoomsNeedCleaning(cols[3]);

                }



                    // const newStartDate = event[0];
                    // const newEndDate = event[1];

                    // alert('in reload')
                    // alert(newStartDate);
                    // alert(startDate.toString())
                    // alert(startDate.toISOString().substr(0, 10).toString())

                    // if (newStartDate.toString() !== startDate.toISOString().substr(0, 10).toString()) {

                    //     alert("INSIDE reload")

                    authenticatedMerchent_context.changeStartDateRange(event[0]);
                    authenticatedMerchent_context.changeEndDateRange(event[1]);

                    setStartDate(new Date(event[0]));
                    setEndDate(new Date(event[1]));

                    // }
            
                    // alert('in reload 2')
                    // alert(newEndDate);
                    // alert(endDate.toString())
                    // alert(endDate.toISOString().substr(0, 10).toString())

                    // if (newEndDate.toString() !== endDate.toISOString().substr(0, 10).toString()) {
                    //     alert("INSIDE reload 2")

                    //setEndDate(event[1].toString());
                    // }
            
                
        })

    }

    function handleRefresh(event)
    {
        // Optional: Delay to show the spinner briefly
        setTimeout(() => {
            event.detail.complete();   // Stop the spinner
            window.location.reload();  // Reload the entire app
        }, 500);
    }

    useEffect(() => {
        
        reloadDates([startDate.toISOString().substr(0, 10), endDate.toISOString().substr(0, 10)]);

   }, []);

//    useEffect(() => {

//   const now = new Date();
//   const currentHour = now.getHours();

//   // If the time right now is exactly 6 AM
//   if (currentHour >= 6) {

//     const start = new Date();           // today
//     const end = new Date();
//     end.setDate(end.getDate() + 1);     // tomorrow

//     setStartDate(start);
//     setEndDate(end);

//     reloadDates([
//       start.toISOString().substr(0, 10),
//       end.toISOString().substr(0, 10)
//     ]);
//   }

// }, []); // Only run once on mount

   //alert("in CheckInCheckOut");
   //alert(authenticatedMerchent_context.startDate);
   

    return (

        <React.Fragment>  
        {notifications.length !== 0 &&
        <IonList>
            {notifications.map((notif) =>
                <IonItem key={notif.id}>
                    <IonLabel>
                        <IonText>
                            <h3 className="notif-title">{notif.title}</h3>
                        </IonText>
                        <p>{notif.body}</p>
                    </IonLabel>
                </IonItem>
            )}
            </IonList>}

        <IonContent  className='appContent'>
            <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                <IonRefresherContent
                pullingText="Pull to refresh the app"
                refreshingSpinner="circles"
                refreshingText="Refreshing app..."
                />
            </IonRefresher>
            <IonItem>
                <IonGrid>
                        <DateRange setDate={(e) => reloadDates(e)} data={{
                        startDate: startDate, 
                        endDate: endDate
                        }}></DateRange>
                </IonGrid>
            </IonItem>
            <IonGrid >
                <IonRow>
                    <IonCol>
                        <h3>Available</h3>
                        <p > {numRoomsAvailable} </p>
                        <IonButton onClick={() => setShowAvailableRoomsModal(true)}> View </IonButton>
                    </IonCol>
                    <IonCol>
                        <h3>Occupied</h3>
                        <p > {numRoomsOccupied} </p>
                        <IonButton onClick={() => setShowOccupiedRoomsModal(true)}> View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>
                        <h3>Booked</h3>
                        <p > {numRoomsBooked} </p>
                        <IonButton > - </IonButton>
                    </IonCol>
                    <IonCol>
                        <h3>Cleaning</h3>
                        <p > {numRoomsNeedCleaning} </p>
                        <IonButton onClick={() => setShowNeedCleaningRoomsModal(true)}> View </IonButton>
                    </IonCol>
                </IonRow>

                {/*{authenticatedMerchent_context.accessRights[0] == 'admin' && 
                    <IonRow>
                        <IonCol>
                                <input placeholder='Search Customer' onChange={ searchGuestDataHandler }></input>
                                <IonButton onClick={() => setSearchGuestDataTracker(74117)}> Search Name</IonButton>
                        </IonCol>
                    </IonRow>}
                {
                    searchGuestDataTracker != null &&
                        <GetGuestSearchMatch tracker={searchGuestDataTracker} searchGuestData={ searchGuestData }></GetGuestSearchMatch>
                }*/}
            </IonGrid>


            {showAvailableRoomsModal == true && <ViewAvailableRoomsModal openModal={ showAvailableRoomsModal } closeModal={() => setShowAvailableRoomsModal(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate}></ViewAvailableRoomsModal>}

            {showOccupiedRoomsModal == true && <ViewOccupiedRoomsModal openModal={ showOccupiedRoomsModal } closeModal={() => setShowOccupiedRoomsModal(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate}></ViewOccupiedRoomsModal>}

            {showBookedRoomsModal == true && <ViewBookedRoomsModal openModal={ showBookedRoomsModal } closeModal={() => setShowBookedRoomsModal(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate}></ViewBookedRoomsModal>}

            {showNeedCleaningRoomsModal == true && <ViewNeedCleaningRoomsModal openModal={ showNeedCleaningRoomsModal } closeModal={() => setShowNeedCleaningRoomsModal(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate} tracker={ 74104 }></ViewNeedCleaningRoomsModal>}



        </IonContent>
        </React.Fragment>   
    )
    //}   
}